<mat-form-field appearance="fill"
  *ngrxLet="viewModel$; let model;"
  class="floatingFilter"
  [class]="model.backgroundClassName">
  <input matInput
    appGxInput
    [readonly]="model.readOnly"
    (click)="showParentFilter()"
    type="text"
    placeholder="{{ 'MULTISELECT.SEARCH' | translate }}"
    [formControl]="inputFormControl"/>
    @if (model.hasValue) {
      <button
        matSuffix
        mat-icon-button
        (click)="resetParentFilter()">
        <mat-icon svgIcon="close" class="closeIcon"></mat-icon>
      </button>
    }
  </mat-form-field>